import React, { useEffect, useState } from 'react';
import './Vitaminas.css';
import CardPratos from './../CardPratos/CardPratos';
import { getFirestore, getDocs, collection } from 'firebase/firestore';
import { fireBaseApp } from './../../App';

const Vitaminas = () => {
  const [pratos, setPratos] = useState([]);

  const db = getFirestore(fireBaseApp);
  const cardapioRef = collection(db, 'Vitaminas');

  const getPratos = async () => {
    const data = await getDocs(cardapioRef);
    const vitaminas = data.docs.map(doc => doc.data());
    setPratos(vitaminas);
  };

  useEffect(() => {
    getPratos();
  }, []);

  return (
    <section id="vitaminas">
      <h2>VITAMINAS</h2>
      <ul>
        {pratos.map((prato, index) => (
          <CardPratos prato={prato} key={`@vitaminas-${index}`} />
        ))}
      </ul>
    </section>
  );
};

export default Vitaminas;
